export default {
    submitFormVisible(state) {
        const isCoverSearchVoting = state.contest.type === 'cover_search_contest' && state.contest.status === 'vote';
        if (state.contest.status === 'submit' || isCoverSearchVoting) {
            return true;
        }
    },
}


